import { render, staticRenderFns } from "./CTABanner.vue?vue&type=template&id=2d41b57c"
import script from "./CTABanner.vue?vue&type=script&lang=js"
export * from "./CTABanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports